import React from 'react';
import PropTypes from 'prop-types';
import './Button.css';

const Button = ({onClick, selected, children, small, type, className, disabled}) => {
  let classNames = ["Button"];
  if ( className ) classNames.push(className);
  if ( selected ) classNames.push("active");
  if ( small ) classNames.push("small")
  if ( type === "delete" ) classNames.push("type-delete");

  return (
    <button className={classNames.join(" ")} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  )
};

Button.defaultProps = {
  small: false,
  selected: false,
  disabled: false,
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  onClick: PropTypes.func,
  selected: PropTypes.bool.isRequired,
  small: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([
    "delete"
  ]),
  disabled: PropTypes.bool.isRequired,
};

export default Button;



// WEBPACK FOOTER //
// ./src/component/atoms/Button/index.js